import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row justify-between" }
const _hoisted_2 = { class: "text-subtitle2 text-blue-grey-7" }
const _hoisted_3 = { class: "row justify-between items-center q-mt-xs q-mb-sm" }
const _hoisted_4 = { class: "text-h4 text-info" }
const _hoisted_5 = { class: "row text-h6" }
const _hoisted_6 = { class: "text-weight-regular text-blue-grey-7" }
const _hoisted_7 = { class: "text-weight-bold" }

import SfxCard from "src/components/card/SfxCard.vue"
import SfxUserData from "src/components/special/SfxUserData.vue"
import { useUserStore } from "src/stores/userStore"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getPriorityColor, translateEventName } from "src/util/functions/notifications"
import { getTemporalInfo } from "src/util/functions/time"
import { getUserWithAvatarData } from "src/util/functions/user"
import { IconRowElement } from "src/util/types/components/sfxIconRow"
import { UserWithAvatar } from "src/util/types/dataModels/user"
import { UserNotificationCardData } from "src/util/types/notifications"
import { computed, onBeforeMount, PropType, ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardNotificationUser',
  props: {
  data: {
    type: Object as PropType<UserNotificationCardData>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const userStore = useUserStore()
const userData = ref<UserWithAvatar>()
const userClasses = ["text-subtitle2", "text-blue-grey-7"]

const iconRowElements = computed<IconRowElement[]>(() => {
  const icons = []

  const itemOrAreaIcon = {
    name: props.data.hasItem ? Icons.ITEM : Icons.AREAS,
    color: "blue-grey-6",
  }

  icons.push(itemOrAreaIcon)

  if (props.data.hasIssue) {
    icons.push({
      name: Icons.ISSUE,
      color: getPriorityColor(props.data.priority || 0),
    })
  } else if (props.data.hasWorkOrder) {
    icons.push({
      name: Icons.WORK_ORDERS,
      color: getPriorityColor(props.data.priority || 0),
    })
  }

  return icons
})

const timeSinceReceived = computed(() => {
  let date = props.data.timeSinceReceived
  if (date instanceof Date) {
    date = date.toJSON()
  }
  return getTemporalInfo(date, "card")
})

const eventName = translateEventName(props.data.eventName)

// TODO: Make a check if the object (work order/issue) exists when we have the data, then change the value accordingly
// TODO: If it doesn't exist a dialog should state that.
const referenceExists = ref(true)

//endregion

//region Lifecycle

onBeforeMount(async () => {
  // TODO: Needs to be changed with getUserAvatar(id: ...) when we have the data
  userData.value = await getUserWithAvatarData(userStore.id)
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(SfxCard, {
    class: "q-mb-sm sfx-card-notification",
    active: "",
    "icon-row": iconRowElements.value,
    clickable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SfxUserData, {
          "user-data": userData.value,
          "user-name-classes": userClasses
        }, null, 8, ["user-data"]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(timeSinceReceived.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(eventName)), 1),
        (referenceExists.value)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: _unref(Icons).INTERNAL_LINK,
              size: "xs",
              class: "no-padding"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(props.data.relationId) + " ", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(props.data.relationRepresentation), 1)
      ])
    ]),
    _: 1
  }, 8, ["icon-row"]))
}
}

})